module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Maryann Burk Carver\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("MARYANN BURK CARVER is a teacher living on Lummi Island in Washington State.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17sggYY/tc-custom/9781429902687.jpg?1737197407185",
      "alt": "This image is the cover for the book What It Used to Be Like"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("What It Used to Be Like\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Maryann Burk Carver met Raymond Carver in 1955, when she was fifteen years old and he was seventeen. In "), _c('i', [_vm._v("What It Used to Be Like")]), _vm._v(", she recounts a tale of love at first sight in which two teenagers got to know each other by sharing a two-year long-distance correspondence that soon after found them married and with two small children."), _c('br'), _c('br'), _vm._v("Over the next twenty-five years, as Carver's fame grew, the family led a nomadic life, moving from school to school and teaching post to teaching post. In 1972, they settled in Cupertino, California, where Raymond Carver gave his wife one of his sharpened pencils and asked her to write an account of their history."), _c('br'), _c('br'), _vm._v("The result is a memoir of a marriage, replete with an intimacy of detail that fully reveals the talents and failings of this larger-than-life man, his complicated relationships, and his profound loves and losses. "), _c('i', [_vm._v("What It Used to Be Like")]), _vm._v(" brings to light for the first time Raymond Carver's lost years and the \"stories behind the stories\" of this brilliant writer.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Press\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0